module.exports = __webpack_public_path__ + "img/3.828506fc.png";